<template>
    <section class="uses-tailwind w-full">
        <div
            class="bg-slate-400 h-5 rounded-lg overflow-hidden w-full relative"
            @click="progress += 10"
        >
            <div
                class="h-full bg-success-dark"
                :style="{
                    backgroundColor: progressColor,
                    width: `${progress}%`,
                }"
            ></div>
            <p
                class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white text-sm"
            >
                {{ progress }}%
            </p>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        progress: {
            type: Number,
            required: true,
            default: 0,
        },
    },
    data() {
        return {
            startColor: { r: 128, g: 128, b: 128 },
            endColor: { r: 61, g: 139, b: 64 },
        };
    },
    computed: {
        progressColor() {
            const progress = Math.max(0, Math.min(100, this.progress));

            // Interpolate each color channel
            const r = Math.round(
                this.startColor.r +
                    (this.endColor.r - this.startColor.r) * (progress / 100)
            );
            const g = Math.round(
                this.startColor.g +
                    (this.endColor.g - this.startColor.g) * (progress / 100)
            );
            const b = Math.round(
                this.startColor.b +
                    (this.endColor.b - this.startColor.b) * (progress / 100)
            );

            // Return the interpolated color as an RGB string
            return `rgb(${r}, ${g}, ${b})`;
        },
    },
};
</script>
